import React, { FC } from "react";
import { Stack } from "@mui/material";
import { useField } from "formik";
import { FieldError } from "../FieldError/FieldError";
import { CustomFieldLabel } from "../CustomFieldLabel/CustomFieldLabel";
import { styled } from "@mui/material/styles";

interface Props {
  name: string;
  label: string;
  placeholder?: string;
  rows?: number;
  required?: boolean;
}

export const CustomTextArea: FC<Props> = ({
  name,
  label,
  rows = 2,
  required = false,
  placeholder,
}) => {
  const [field, meta] = useField(name);

  return (
    <Stack mb={3} className="field-container">
      {label && <CustomFieldLabel required={required}>{label}</CustomFieldLabel>}
      <StyledTextArea {...field} placeholder={placeholder} rows={rows} />
      {!!meta.touched && !!meta.error && <FieldError>{meta.error}</FieldError>}
    </Stack>
  );
};

// Styled Component for TextArea
const StyledTextArea = styled("textarea")(({ theme }) => ({
  width: "100%",
  padding: "12px",
  borderRadius: "12px",
  backgroundColor: "var(--Base-24, #F4F4F4)",
  outline: "none",
  border: "none",
  fontFamily: "CircularStd",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 500,
  lineHeight: "normal",
  resize: "none",

  "&::placeholder": {
    color: "var(--Base-300, #B0B0B0)",
    opacity:"0.5",
    fontFamily: "CircularStd",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 450,
    lineHeight: "normal",
  },

  "&:focus": {
    outline: "none",
    boxShadow: "none",
    border: "none",
  },

  "&:-webkit-autofill": {
    WebkitBoxShadow: "0 0 0px 1000px var(--Base-24, #F4F4F4) inset !important",
    backgroundColor: "var(--Base-24, #F4F4F4) !important",
    color: "var(--Base-1000, #000) !important",
    border: "none !important",
    transition: "background-color 5000s ease-in-out 0s",
  },
}));
